import {DefaultContextMenu} from "./DefaultContextMenu";
import {openModal} from "../../utilities";
import {toLonLat} from "ol/proj";
import {confirmModal} from "../../confirmModal";
import {InventoryLocationInteractionMode} from "../../app/inventories/locations/interactions/interaction";
import * as $ from "jquery";

export class InventoryLocationsEditorContextMenu extends DefaultContextMenu {
    constructor() {
        super();

        if(window._interactionsHandler && window._interactionsHandler.interactions.location) {
            this.addItem({
                name: 'edit_location',
                group: 'edit',
                title: () => {
                    if (!window._interactionsHandler.interactions.location.features.length) {
                        return 'Rysuj obszar'
                    }

                    return window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.EDIT ? 'Zakończ edycję obszaru' : 'Edytuj obszar'
                },
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.location.enabled === false) {
                        return false;
                    }

                    if (window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.DRAW) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'location');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.EDIT ||
                        window._interactionsHandler.interactions.location.features.length === 0;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.location.toggleInteraction();

                    return true;
                }
            })

            this.addItem({
                name: 'delete_location',
                group: 'edit',
                title: 'Usuń obszar',
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.location.enabled === false) {
                        return false;
                    }

                    if (!window._interactionsHandler.interactions.location.features.length) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'location');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.location.mode === InventoryLocationInteractionMode.EDIT ||
                        window._interactionsHandler.interactions.location.features.length === 0;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.location.toggleDelete(window._interactionsHandler.interactions.location.features[0].get('id'));

                    return true;
                }
            })
        }

        if(window._interactionsHandler && window._interactionsHandler.interactions.observers_line) {
            this.addItem({
                name: 'edit_observers_line',
                group: 'edit',
                title: () => {
                    if (!window._interactionsHandler.interactions.observers_line.features.length) {
                        return 'Rysuj linię obserwacji'
                    }

                    return window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.EDIT ? 'Zakończ edycję linii obserwacji' : 'Edytuj linię obserwacji'
                },
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.observers_line.enabled === false) {
                        return false;
                    }

                    if (window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.DRAW) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'observers_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.observers_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.observers_line.toggleInteraction();

                    return true;
                }
            })

            this.addItem({
                name: 'delete_observers_line',
                group: 'edit',
                title: 'Usuń linię obserwacji',
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.observers_line.enabled === false) {
                        return false;
                    }

                    if (!window._interactionsHandler.interactions.observers_line.features.length) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'observers_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.observers_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.observers_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.observers_line.toggleDelete(window._interactionsHandler.interactions.observers_line.features[0].get('id'));

                    return true;
                }
            })
        }

        if(window._interactionsHandler && window._interactionsHandler.interactions.beaters_line) {
            this.addItem({
                name: 'edit_beaters_line',
                group: 'edit',
                title: () => {
                    if (!window._interactionsHandler.interactions.beaters_line.features.length) {
                        return 'Rysuj linię naganki'
                    }

                    return window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.EDIT ? 'Zakończ edycję linii naganki' : 'Edytuj linię naganki'
                },
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.beaters_line.enabled === false) {
                        return false;
                    }

                    if (window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.DRAW) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'beaters_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.beaters_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.beaters_line.toggleInteraction();

                    return true;
                }
            })

            this.addItem({
                name: 'delete_beaters_line',
                group: 'edit',
                title: 'Usuń linię naganki',
                shouldRender: (contextMenuFeature) => {
                    if (window._interactionsHandler.interactions.beaters_line.enabled === false) {
                        return false;
                    }

                    if (!window._interactionsHandler.interactions.beaters_line.features.length) {
                        return false;
                    }

                    let features = contextMenuFeature
                        .getFeaturesAtClickedPosition(10)
                        .filter(feature => feature.get('type') === 'beaters_line');

                    return features.length > 0 ||
                        window._interactionsHandler.interactions.beaters_line.mode === InventoryLocationInteractionMode.EDIT ||
                        !window._interactionsHandler.interactions.beaters_line.features.length;
                },
                onClick: () => {
                    window._interactionsHandler.interactions.beaters_line.toggleDelete(window._interactionsHandler.interactions.beaters_line.features[0].get('id'));

                    return true;
                }
            })
        }

        this.addItem({
            name: 'point',
            group: 'location_points',
            title: (contextMenuFeature) => {
                let editing = contextMenuFeature.getFeaturesAtClickedPosition()
                    .filter(feature => feature.get('type') === 'location_point')
                    .length > 0;

                return editing ? 'Edytuj punkt' : 'Dodaj punkt';
            },
            onClick: (contextMenuFeature) => {
                let editing = contextMenuFeature.getFeaturesAtClickedPosition()
                    .filter(feature => feature.get('type') === 'location_point')
                    .length > 0;

                const modal = $('#pointModal');

                modal.find('.modal-title').text(editing ? 'Edycja punktu' : 'Dodawanie punktu');

                let latitude = toLonLat(contextMenuFeature.position)[1].toFixed(4);
                let longitude = toLonLat(contextMenuFeature.position)[0].toFixed(4);
                let name = '';
                let id = '';
                let isNew = true;

                if(editing) {
                    let feature = contextMenuFeature.getFeaturesAtClickedPosition()
                        .find(feature => feature.get('type') === 'location_point')

                    id = feature.get('id');

                    name = $(`[name="points[${id}][name]"]`).val();
                    latitude = $(`[name="points[${id}][latitude]"]`).val();
                    longitude = $(`[name="points[${id}][longitude]"]`).val();
                    isNew = $(`[name="points[${id}][is_new]"]`).val();
                }

                modal.find('[name="id"]').val(id)
                modal.find('[name="name"]').val(name)
                modal.find('[name="latitude"]').val(latitude)
                modal.find('[name="longitude"]').val(longitude)
                modal.find('[name="is_new"]').val(isNew)

                openModal('#pointModal');

                return true;
            }
        })

        this.addItem({
            name: 'delete_point',
            group: 'location_points',
            title: 'Usuń punkt',
            shouldRender: (contextMenuFeature) => {
                return contextMenuFeature.getFeaturesAtClickedPosition()
                    .filter(feature => feature.get('type') === 'location_point')
                    .length > 0;
            },
            onClick: async (contextMenuFeature) => {
                if(await confirmModal('Czy na pewno chcesz usunąć ten punkt?')) {
                    let feature = contextMenuFeature.getFeaturesAtClickedPosition()
                        .find(feature => feature.get('type') === 'location_point');

                    contextMenuFeature
                        .epMap
                        .getEpLayerByName('location_points')
                        .getSource()
                        .removeFeature(feature);

                    let id = feature.get('id');
                    $(`[name="points[${id}][name]"]`).remove();
                    $(`[name="points[${id}][latitude]"]`).remove();
                    $(`[name="points[${id}][longitude]"]`).remove();
                    $(`[name="points[${id}][is_new]"]`).remove();

                    const container = $('[data-app-map_interaction_container="points"]')
                    const table = container.find('table').DataTable()
                    const row = table.$(`tr[data-id="${id}"]`);
                    table.api().row(row).remove().draw();
                }

                return true;
            }
        })
    }
}